<ng-container *transloco="let tr; prefix:'compositeProducts'; scope: 'composite-products'">
  <form nz-form [nzLayout]="'vertical'" [formGroup]="subProductForm" (ngSubmit)="submitForm()">
    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label nzRequired>Продукт</nz-form-label>
          <nz-form-control>
            <hx-product-info-select formControlName="productDefinitionId"></hx-product-info-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label nzRequired>Наименование</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="title"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="6">
        <nz-form-item>
          <nz-form-label nzRequired>
            Кол-во <i class="cp__info" nz-icon nz-tooltip nzTooltipTitle="Кол-во продукта для продажи, половинка - 0.5, полный - 1.0" nzType="question-circle"
                      nzTheme="outline"></i>
          </nz-form-label>
          <nz-form-control>
            <nz-input-number formControlName="priceAmount" [nzMin]="0.1" [nzMax]="1000" [nzStep]="0.1"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-form-item>
          <nz-form-label nzRequired>
            Порядок <i class="cp__info" nz-icon nz-tooltip nzTooltipTitle="Порядок сортировки" nzType="question-circle" nzTheme="outline"></i>
          </nz-form-label>
          <nz-form-control>
            <nz-input-number
              formControlName="sortOrder"
              [nzMin]="1"
              [nzMax]="1000"
              [nzStep]="1"
            ></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </form>

  <div *nzModalFooter>
    <button (click)="modalRef.close()" nz-button nzType="default">Отменить</button>
    <button (click)="submitForm()" nz-button nzType="primary">Ок</button>
  </div>
</ng-container>
